const DigitalPrice = {
	// Captures charges by video quantity input
	rule: function (price, quantity) {
		const upsellTotal =
			Number($(".product-price").attr("data-upsell-dvd-total-price")) +
			Number($(".product-price").attr("data-upsell-usb-total-price"));
		var newPrice = 0;
		newPrice += price * Math.max(1, quantity);
		newPrice += upsellTotal;
		return [newPrice, formatMoney(newPrice)];
	},
	variants: function (callback) {
		var digitalQuantityInput = $('input[name="digital-quantity"]');
		var submitButton = $("button.product-form__submit");
		var errorMessageWrapper = $(".product-digital__error-message-wrapper");
		// default quantity > 1 so enable button
		submitButton.prop("disabled", false);
		digitalQuantityInput.change(function (e) {
			var value = Number($(this).val());
			if (value > CONSTANTS.DIGITAL.THRESHOLD) {
				$(this).val(CONSTANTS.DIGITAL.THRESHOLD);
				value = CONSTANTS.DIGITAL.THRESHOLD;
				errorMessageWrapper.removeAttr("hidden");
				errorMessageWrapper
					.find(".product-digital__error-message")
					.text(
						`Maximum quantity for digital input is ${CONSTANTS.DIGITAL.THRESHOLD}`
					);
			} else {
				errorMessageWrapper.attr("hidden", true);
			}

			if (value > 0) {
				if (submitButton.prop("disabled")) {
					submitButton.prop("disabled", false);
				}
			} else {
				submitButton.prop("disabled", true);
			}

			if (callback) {
				callback(value);
			}
		});
	},
};

document.addEventListener("DOMContentLoaded", () => {
	const priceRegularWrapper = $(".product-price .price-item--regular");
	const priceSaleWrapper = $(".product-price .price-item--sale");
	const originalPrice = Number(
		$(".product-price").attr("data-compare-price")
	);
	const originalSalePrice = Number($(".product-price").attr("data-price"));

	DigitalPrice.variants((quantity) => {
		const [newPriceRegular, newPriceRegularFormatted] = DigitalPrice.rule(
			originalPrice,
			quantity
		);
		const [newPriceSale, newPriceSaleFormatted] = DigitalPrice.rule(
			originalSalePrice,
			quantity
		);
		priceRegularWrapper.text(newPriceRegularFormatted);
		priceSaleWrapper.text(newPriceSaleFormatted);
		$(".product-price").attr("data-total-price", newPriceSale);
		$(".product-price").attr("data-total-compare-price", newPriceRegular);
	});
});
